<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "flatpickr/dist/flatpickr.css";
import iranCities from "../../../components/iran-cities";

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";

import axios from "axios";
import { authGetters, authActions } from "@/state/helpers";
export default {
    page: {
        title: "ویرایش پروفایل",
        meta: [{ name: "description", content: appConfig.description }],
    },
    data() {
        return {
            title: "ویرایش پروفایل",
            date: null,
            profileIsUpdating: false,
            bannerIsUpdating: false,
            logoIsUpdating: false,
            formIsUpdating: false
        };
    },
    components: {
        Layout,
        Multiselect,
        iranCities
    },
    created() {
    },
    computed: {
        ...authGetters,
        profile() {
            return this.getUser;
        },
        field() {
            return Array.isArray(this.profile.field) ? this.profile.field : [this.profile.field];
        },
        profileHelper() {
            return this.profile;
        },
        get_vendor_type() {
            if( this.profile.vendor_type === 'designer' )
                return 'طراح';

            if( this.profile.vendor_type === 'brand' )
                return 'برند';

            return 'نامشخص'
        },
    },
    methods: {
        ...authActions,
        updateProfileField(fieldId, updatedValue) {
            this.$store.dispatch('auth/updateProfileField', {profile: this.profile, fieldId, updatedValue});
        },
        updateProfileState(data) {
            this.$store.dispatch('auth/updateProfileState', {profile: data});
        },
        onBannerSelect() {
            this.bannerIsUpdating = true;
            this.updateProfileHandler(this.profileHelper);
        },
        onLogoSelect() {
            this.logoIsUpdating = true;
            this.updateProfileHandler(this.profileHelper);
        },
        onFormSubmit() {
            this.formIsUpdating = true;
            this.profileHelper = this.profile;
            this.updateProfileHandler(this.profileHelper);
        },
        updateProfileHandler(fields) {
            this.profileIsUpdating = true;
            let fd = new FormData();
            let banner = this.$refs.bannerInput.files;
            if(banner.length) {
                fd.append('banner', banner[0], banner[0].name);
            }
            let logo = this.$refs.logoInput.files;
            if(logo.length) {
                fd.append('logo', logo[0], logo[0].name);
            }
            fd.append('fname', fields.fname);
            fd.append('lname', fields.lname);
            fd.append('email', fields.email);
            fd.append('field', this.field);
            fd.append('state', fields.state);
            fd.append('city', fields.city);
            fd.append('postal_code', fields.postal_code);
            fd.append('description', fields.description);

            return new Promise((resolve, reject) => {
                this.profileIsUpdating = true;
                axios.post('/vendor/profile/update', fd, {
                    // onUploadProgress: uploadEvent => {
                    //   console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total));
                    // }
                })
                    .then((response) => {
                        const {data} = response;
                        resolve(response);
                        this.updateProfileState(data.vendor_data);
                        this.$refs.bannerInput.value = '';
                        this.$refs.logoInput.value = '';
                        this.$notify({
                            title: "اطلاعات ذخیره شد.",
                            text: "تا تایید تغییرات منتظر بمانید.",
                            type: 'success',
                        });
                    }, (error) => {
                        reject(error);
                    })
                    .then(() => {
                        this.profileIsUpdating = false;
                        this.bannerIsUpdating = false;
                        this.logoIsUpdating = false;
                        this.formIsUpdating = false;
                    });
            });
        }
    }
};
</script>

<template>
    <Layout>
        <div class="position-relative mx-n4 mt-n4">
            <div class="profile-wid-bg profile-setting-img">
                <img
                    :src="profile.banner_url"
                    class="profile-wid-img"
                    alt=""
                />

                <div class="panel-spinner-overlay" v-if="bannerIsUpdating">
                    <b-spinner variant="warning"></b-spinner>
                </div>

                <div class="overlay-content">
                    <div class="text-end p-3">
                        <div class="p-0 ms-auto rounded-circle profile-photo-edit">
                            <input
                                id="profile-foreground-img-file-input"
                                type="file"
                                class="profile-foreground-img-file-input"
                                @change="onBannerSelect"
                                ref="bannerInput"
                                :disabled="profileIsUpdating"
                            />
                            <label
                                for="profile-foreground-img-file-input"
                                class="profile-photo-edit btn btn-light"
                            >
                                <i class="ri-image-edit-line align-bottom me-1"></i>
                                تغییر کاور
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xxl-3">
                <div class="card mt-n5">
                    <div class="card-body p-4">
                        <div class="text-center">
                            <div
                                class="
                  profile-user
                  position-relative
                  d-inline-block
                  mx-auto
                  mb-4
                "
                            >
                                <img
                                    :src="profile.logo_url"
                                    class="
                    rounded-circle
                    avatar-xl
                    img-thumbnail
                    user-profile-image
                  "
                                    alt="user-profile-image"
                                />
                                <div class="panel-spinner-overlay" v-if="logoIsUpdating">
                                    <b-spinner variant="warning"></b-spinner>
                                </div>
                                <div class="avatar-xs p-0 rounded-circle profile-photo-edit">
                                    <input
                                        id="profile-img-file-input"
                                        type="file"
                                        class="profile-img-file-input"
                                        ref="logoInput"
                                        @change="onLogoSelect"
                                        :disabled="profileIsUpdating"
                                    />
                                    <label
                                        for="profile-img-file-input"
                                        class="profile-photo-edit avatar-xs"
                                    >
                                        <span class="avatar-title rounded-circle bg-light text-body"><i class="ri-camera-fill"></i></span>
                                    </label>
                                </div>
                            </div>
                            <h5 class="fs-16 mb-1">{{ profile.shop_name }}</h5>
                            <p class="text-muted mb-0">{{get_vendor_type}}</p>
                        </div>
                    </div>
                </div>
                <!--end card-->
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-4">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">شبکه‌های اجتماعی</h5>
                            </div>
                        </div>
                        <div class="mb-3 d-flex">
                            <div class="avatar-xs d-block flex-shrink-0 me-3">
                <span class="avatar-title rounded-circle fs-16 bg-dark text-light">
                  <i class="ri-instagram-line"></i>
                </span>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                id="instagramUsername"
                                placeholder="اینستاگرام"
                            />
                        </div>
                        <div class="mb-3 d-flex">
                            <div class="avatar-xs d-block flex-shrink-0 me-3">
                <span class="avatar-title rounded-circle fs-16 bg-primary">
                  <i class="ri-global-fill"></i>
                </span>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                id="websiteInput"
                                placeholder="آدرس وبسایت"
                            />
                        </div>
                    </div>
                </div>
                <!--end card-->
            </div>
            <!--end col-->
            <div class="col-xxl-9">
                <div class="card mt-xxl-n5">
                    <div class="card-body p-4">
                        <div class="tab-content">
                            <form action="javascript:void(0);" @submit.prevent="onFormSubmit">

                                <div class="panel-spinner-overlay" v-if="formIsUpdating">
                                    <b-spinner variant="warning"></b-spinner>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label for="firstnameInput" class="form-label">نام</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="firstnameInput"
                                                placeholder="نام شما"
                                                :value="profile.fname"
                                                @input="updateProfileField('fname', $event.target.value)"
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label for="lastnameInput" class="form-label"
                                            >نام خانوادگی</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="lastnameInput"
                                                placeholder="نام خانوادگی شما"
                                                :value="profile.lname"
                                                @input="updateProfileField('lname', $event.target.value)"
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label for="phonenumberInput" class="form-label">شماره موبایل</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="phonenumberInput"
                                                :value="profile.display_phone"
                                                placeholder="شماره همراه شما"
                                                readonly
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label for="emailInput" class="form-label">ایمیل</label>
                                            <input
                                                type="email"
                                                class="form-control"
                                                id="emailInput"
                                                placeholder="ایمیل شما"
                                                :value="profile.email"
                                                @input="updateProfileField('email', $event.target.value)"
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <label for="fieldInput" class="form-label">حوزه فعالیت</label>
                                            <Multiselect
                                                :value="profile.field"
                                                @input="updateProfileField('field', $event.target.value)"
                                                mode="tags"
                                                :close-on-select="false"
                                                :searchable="true"
                                                :create-option="true"
                                                :options="[
                            { value: 'gold', label: 'طلا' },
                            { value: 'silver', label: 'نقره' },
                            { value: 'jewelry', label: 'جواهرات' },
                            { value: 'other', label: 'سایر' }
                          ]"
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-8">
                                        <iran-cities :province-model="profile.state" :city-model="profile.city" default-province="تهران" default-city="تهران"></iran-cities>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-4">
                                        <div class="mb-3">
                                            <label for="zipcodeInput" class="form-label">کد پستی</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                minlength="5"
                                                maxlength="6"
                                                id="zipcodeInput"
                                                placeholder="کد پستی شما"
                                                :value="profile.postal_code"
                                                @input="updateProfileField('postal_code', $event.target.value)"
                                            />
                                        </div>
                                    </div>
                                    <!--end col-->

                                    <div class="col-lg-12">
                                        <div class="mb-3 pb-2">
                                            <label
                                                for="exampleFormControlTextarea"
                                                class="form-label"
                                            >توضیحات فروشگاه</label
                                            >
                                            <textarea
                                                class="form-control"
                                                id="exampleFormControlTextarea"
                                                placeholder="Enter your description"
                                                v-html="profile.description"
                                                @input="updateProfileField('description', $event.target.value)"
                                                rows="3"></textarea>
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-lg-12">
                                        <div class="hstack gap-2 justify-content-end">
                                            <button type="submit" class="btn btn-primary">
                                                ثبت تغییرات
                                            </button>
                                        </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                <!--end row-->
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </Layout>
</template>
